<template>
    <div class="captcha-input" :class="'captcha-input--' + variant">
        <div class="captcha-input__row">
            <input
                ref="field"
                type="text"
                class="captcha-input__field"
                name="captcha"
                autocomplete="off"
                :placeholder="lang($t('Captcha'))"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @keyup.enter="$emit('enter')"
            >
            <a
                href="javascript:void(0)"
                class="captcha-input__image"
                :title="lang($t('Click to refresh captcha'))"
                @click.prevent="refresh"
            >
                <img v-if="img" :src="img" alt="captcha">
                <span v-else class="captcha-input__placeholder">...</span>
            </a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { common } from "@mixins/common";

export default {
    name: "CaptchaInput",
    mixins: [common],
    props: {
        value: {
            type: String,
            default: ""
        },
        variant: {
            type: String,
            default: "popup" // popup | compact | entry
        }
    },
    data() {
        return {
            key: "",
            img: ""
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.$emit('input', '');
            return axios.get('/captcha/api/flat').then(resp => {
                const data = resp.data || {};
                this.key = data.key || "";
                this.img = data.img || "";
            }).catch(() => {
                this.key = "";
                this.img = "";
            });
        },
        getPayload() {
            var fromProp = (this.value || "").trim();
            var fromDom = "";
            if (this.$refs.field && typeof this.$refs.field.value === "string") {
                fromDom = this.$refs.field.value.trim();
            }
            return {
                captcha: fromProp || fromDom,
                key: this.key
            };
        }
    }
};
</script>

<style scoped lang="scss">
.captcha-input {
    width: 100%;
}

.captcha-input__row {
    display: flex;
    align-items: center;
    width: 100%;
}

.captcha-input__image {
    flex: 0 0 auto;
    display: block;
    line-height: 0;
    cursor: pointer;
    border: 1px solid #bfbfbf;
    border-radius: 6px;
    overflow: hidden;
    background: #ecf2f4;
    margin-left: 0.5rem;
}

.captcha-input__image img {
    display: block;
    height: 36px;
    width: auto;
    object-fit: contain;
}

.captcha-input__placeholder {
    display: inline-block;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #a3a3a3;
    font-size: 0.875rem;
}

.captcha-input__field {
    flex: 1 1 auto;
    min-width: 0;
}

/* popup: match LoginPopup inputs */
.captcha-input--popup {
    margin-bottom: 1rem;
}

.captcha-input--popup .captcha-input__field {
    font-size: 1rem;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    border: 1px solid #bfbfbf;
    background-color: #fff;
    border-radius: 6px;
    margin-bottom: 0;
    width: 100%;
}

.captcha-input--popup .captcha-input__image {
    height: 3rem;
    box-sizing: border-box;
}

.captcha-input--popup .captcha-input__image img,
.captcha-input--popup .captcha-input__placeholder {
    height: calc(3rem - 2px);
    width: auto;
    min-width: 120px;
    object-fit: contain;
}

.captcha-input--popup .captcha-input__placeholder {
    line-height: calc(3rem - 2px);
}

/* compact: header login boxes */
.captcha-input--compact {
    margin: 5px;
    width: calc(100% - 10px);
}

.captcha-input--compact .captcha-input__row {
    flex-direction: column-reverse;
    align-items: stretch;
}

.captcha-input--compact .captcha-input__image {
    width: 100%;
    border-radius: 10px;
    border: none;
    margin-left: 0;
    margin-bottom: 5px;
}

.captcha-input--compact .captcha-input__image img,
.captcha-input--compact .captcha-input__placeholder {
    width: 100%;
    height: 32px;
    object-fit: contain;
}

.captcha-input--compact .captcha-input__placeholder {
    line-height: 32px;
}

.captcha-input--compact .captcha-input__field {
    color: #999999;
    padding: 5px 10px;
    background-color: #ffffcd;
    border-radius: 10px;
    outline: 0;
    border: none;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
}

/* entry: full-page login (Secchi/Prihum student) */
.captcha-input--entry {
    margin-top: 10px;
}

.captcha-input--entry .captcha-input__field {
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    border: 1px solid #bfbfbf;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CaptchaInput.vue